import { createContext, useState } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(sessionStorage.getItem('bo-token') || null)
    const [email, setEmail] = useState(sessionStorage.getItem('bo-email') || null);

    const navigate = useNavigate();

    const verifyUser = () => {
        try {
            const jwt = jwt_decode(user);
            if (jwt.uuid && jwt.role) {
                return { access: true, role: jwt.role };
            } else {
                logout();
                return { access: false };
            }
        } catch {
            logout();
            return { access: false };
        }
    };

    const login = (token, email, redirectTo = "/") => {
        sessionStorage.setItem("bo-token", token);
        sessionStorage.setItem("bo-email", email);
        setUser(token);
        setEmail(email);
        navigate(redirectTo); // 👈 redirect after login
    };

    const logout = () => {
        sessionStorage.clear();
        setUser(null);
        setEmail(null);
        navigate("/");
    };

    return <AuthContext.Provider value={{ setUser, login, logout, user, email, verifyUser }}>{children}</AuthContext.Provider>
}

export default AuthContext